import { apiFetch } from '@/api/client'
import { createWorkspaceResourceApi } from '@/api/endpoints/workspaceResource'

const vendors = createWorkspaceResourceApi('vendors')
const multipart = { 'Content-Type': 'multipart/form-data' }
const workspace = (workspaceId) => `workspaces/${workspaceId}`

export const vendorsApi = {
  list: vendors.list,
  get: vendors.get,
  remove: vendors.remove,
  resendInvitation: (workspaceId, id) => vendors.action(workspaceId, id, 'resend'),
  sendRenewalEmail: (workspaceId, id) => vendors.action(workspaceId, id, 'renewal-email'),
  addReview: (workspaceId, id, payload) =>
    apiFetch(`${vendors.path(workspaceId)}/${id}/status`, {
      method: 'PUT',
      body: { ...payload, _methods: 'PUT' },
    }),
  invite: (workspaceId, payload) => apiFetch(`${vendors.path(workspaceId)}/invites`, { method: 'POST', body: payload }),
  runAiAnalysis: (workspaceId, id, payload) => vendors.action(workspaceId, id, 'ai-analysis', payload),
  create: (workspaceId, payload) =>
    apiFetch(vendors.path(workspaceId), { method: 'POST', body: payload, headers: multipart }),
  // Laravel method spoofing, kept as the backend expects it.
  update: (workspaceId, id, payload) =>
    apiFetch(`${vendors.path(workspaceId)}/${id}`, {
      method: 'POST',
      body: { ...payload, _method: 'PUT' },
      headers: multipart,
    }),
  generateReport: (workspaceId, id) => vendors.action(workspaceId, id, 'report'),
  uploadDocument: (workspaceId, vendorId, payload) =>
    apiFetch(`${vendors.path(workspaceId)}/${vendorId}/documents`, {
      method: 'POST',
      body: payload,
      headers: multipart,
    }),

  // AML screening
  screenAml: (workspaceId, payload) =>
    apiFetch(`${workspace(workspaceId)}/risks/aml/screen`, { method: 'POST', body: payload }),
  updateAmlCase: (workspaceId, amlId, payload) =>
    apiFetch(`${workspace(workspaceId)}/risks/aml/cases/${amlId}`, { method: 'PUT', body: payload }),

  // Public vendor onboarding (token link, no workspace)
  onboardingForm: (token) => apiFetch(`vendor-onboarding/${token}`),
  submitOnboardingForm: (token, payload) =>
    apiFetch(`vendor-onboarding/${token}`, { method: 'POST', body: payload, headers: multipart }),
}
